import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, EffectFade, Navigation, Pagination } from "swiper";
import "swiper/css";
import "swiper/css/autoplay";
import "swiper/css/effect-fade";
import "swiper/css/navigation";
import "swiper/css/pagination";

const PromotionalArea = () => {
  const swiperParams = {
    modules: [Autoplay, EffectFade, Navigation, Pagination], // 使用するモジュールを指定
    effect: "fade", // フェードモードにする（デフォルトは 'slide'）
    fadeEffect: {
      crossFade: true, // クロスフェードを有効にする（フェードモードの場合 true 推奨）
    },
    slidesPerView: 1, // コンテナ内に表示させるスライド数（CSSでサイズ指定する場合は 'auto'）
    spaceBetween: 0, // スライド間の余白（px）
    centeredSlides: true, // アクティブなスライドを中央に配置する
    loop: true, // 無限ループさせる
    loopAdditionalSlides: 1, // 無限ループさせる場合に複製するスライド数
    speed: 300, // スライドアニメーションのスピード（ミリ秒）
    autoplay: {
      // 自動再生させる
      delay: 10000, // 次のスライドに切り替わるまでの時間（ミリ秒）
      disableOnInteraction: false, // ユーザーが操作しても自動再生を止めない
      waitForTransition: false, // アニメーションの間も自動再生を止めない（最初のスライドの表示時間を揃えたいときに）
    },
    grabCursor: true, // PCでマウスカーソルを「掴む」マークにする
    watchSlidesProgress: true, // スライドの進行状況を監視する
    pagination: {
      el: ".swiper-pagination", // ページネーション要素のクラス
      clickable: true, // クリックによるスライド切り替えを有効にする
      type: "bullets", // 'bullets'（デフォルト） | 'fraction' | 'progressbar'
    },
    navigation: {
      nextEl: ".swiper-button-next", // 「次へ」ボタン要素のクラス
      prevEl: ".swiper-button-prev", // 「前へ」ボタン要素のクラス
    },
    onSlideChange: (swiper) => {
      // console.log('Slide index changed to: ' + (swiper.realIndex + 1));
    },
  };
  return (
    <div className="promoted">
      <Swiper {...swiperParams} className="smdpromoted">
        <SwiperSlide>
          <a
            href="https://smd.mapple.net/?utm_source=mapplelab&utm_medium=lab_banner&utm_campaign=labmojmap2smd"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src="https://labs.mapple.com/img/mapplelab_moj_264x198.png" alt="" />
          </a>
        </SwiperSlide>
        <SwiperSlide>
          <a
            href="https://mapple.com/products/kintone-map/?utm_source=mapplelab"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src="https://labs.mapple.com/img/20240909_kintonepluginbanner_264x198.png" alt="" />
          </a>
        </SwiperSlide>
        <div
          className="swiper-pagination"
          style={{ position: "relative" }}
        ></div>
      </Swiper>
    </div>
  );
};

export default PromotionalArea;
